import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
    flowType: 'pkce',
    onAuthStateChange: (event, session) => {
      if (event === 'SIGNED_OUT' || event === 'USER_DELETED') {
        localStorage.clear();
      }
    },
    storage: {
      getItem: (key) => {
        try {
          return Promise.resolve(localStorage.getItem(key));
        } catch {
          return Promise.resolve(null);
        }
      },
      setItem: (key, value) => {
        try {
          localStorage.setItem(key, value);
          return Promise.resolve();
        } catch {
          return Promise.resolve();
        }
      },
      removeItem: (key) => {
        try {
          localStorage.removeItem(key);
          return Promise.resolve();
        } catch {
          return Promise.resolve();
        }
      }
    }
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web'
    }
  }
});

// Handle session initialization and errors
supabase.auth.getSession().catch((error) => {
  if (error?.message?.includes('session_not_found')) {
    supabase.auth.signOut();
  }
  console.error('Session error:', error);
});

// Enhanced signOut function that handles session cleanup
export async function signOut() {
  try {
    // Local signout first to ensure UI updates immediately
    await supabase.auth.signOut();
    
    // Clear any remaining data
    localStorage.clear();
    sessionStorage.clear();
    
  } catch (error) {
    console.error('Error during sign out:', error);
    // Ensure local cleanup even if there's an error
    localStorage.clear();
    sessionStorage.clear();
  }
}

// Set up auth state change listener
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_OUT' || event === 'USER_DELETED') {
    // Clear any application cache/state if needed
    localStorage.clear();
    sessionStorage.clear();
  } else if (event === 'TOKEN_REFRESHED' && !session) {
    // Handle invalid session
    supabase.auth.signOut();
  }
});